var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileChanged}}),_c('v-btn',{on:{"click":_vm.onUpload}},[_vm._v("Upload")]),(_vm.uploadFinished)?_c('h3',{attrs:{"id":"green"}},[_vm._v("Uploaded successfully")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }